import * as Yup from "yup";
import { SelectOption } from "../../ui/Select";
import { add } from "date-fns";
import UsaStates from "./../../../data/usaStates";
import PickupTimes from "./../../../data/times";
import api from "./../../../api/api";
import { NewCarBookingSuccessResponse, RentalPrice } from "../../../api/types";
import { format } from "date-fns";
import { useState } from "react";
import { AxiosError } from "axios";
import { SendGoogleEvent } from "../../../utils/tracking";

interface DataForm {
  fullName: string;
  birthDate?: Date;
  dropoffPlace: SelectOption;
  email: string;
  licenseExpirationDate?: Date;
  licenseIssuedDate?: Date;
  licenseNumber: string;
  licenseState: SelectOption;
  phone: string;
  pickupTime: SelectOption;
  postalCode: string;
  terms: boolean;
}
const useLogic = (pickupPlace: SelectOption) => {
  const [hasError, setHasError] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");

  const validationSchema = Yup.object().shape({
    fullName: Yup.string().required("Campo requerido"),
    birthDate: Yup.date()
      .required("Campo requerido")
      .max(add(new Date(), { years: -21 }), "Edad miníma es 21 años"),
    email: Yup.string()
      .email("Correo electrónico es inválido")
      .required("Campo requerido"),
    phone: Yup.string()
      .required("Campo requerido")
      .length(15, "Teléfono es inválido"),
    postalCode: Yup.string().required("Campo requerido"),
    licenseNumber: Yup.string().required("Campo requerido").min(5,'Al menos 5 caracteres son requeridos.'),
    licenseState: Yup.object().shape({
      name: Yup.string().required("Campo requerido"),
      value: Yup.string().required("Campo requerido"),
    }),
    licenseIssuedDate: Yup.date()
      .required("Campo requerido")
      .max(new Date(), "Fecha de expedición es inválida"),
    licenseExpirationDate: Yup.date()
      .required("Campo requerido")
      .min(Yup.ref("licenseIssuedDate"), "Fecha de expiración es inválida"),
    pickupTime: Yup.object().shape({
      name: Yup.string().required("Campo requerido"),
      value: Yup.string().required("Campo requerido"),
    }),

    dropoffPlace: Yup.object().shape({
      name: Yup.string().required("Campo requerido"),
      value: Yup.string().required("Campo requerido"),
    }),
    terms: Yup.boolean().isTrue(),
  });

  const initialValues: DataForm = {
    fullName: "",
    birthDate: undefined,
    email: "",
    phone: "",
    postalCode: "",
    licenseNumber: "",
    licenseState: { name: "Seleccione", value: "" } as SelectOption,
    licenseIssuedDate: undefined,
    licenseExpirationDate: undefined,
    pickupTime: { name: "Seleccione", value: "" } as SelectOption,
    dropoffPlace: pickupPlace,
    terms: false,
  };

  const stateslist: SelectOption[] = UsaStates.map((x) => {
    return { name: x.name, value: x.abbreviation };
  });

  const pickupTimes: SelectOption[] = PickupTimes.map((x) => {
    var time = new Date(2022, 1, 1, x.hour, x.min);
    return {
      name: format(time, "hh:mm aa"),
      value: time.toString(),
    };
  });

  const onSubmit = async (
    values: DataForm,
    offer: RentalPrice,
    pickupPlace: SelectOption,
    setBooking: (booking: NewCarBookingSuccessResponse) => void
  ) => {
    setErrorMessage("");
    setHasError(false);

    await api
      .postNewBooking({
        fullName: values.fullName,
        email: values.email,
        phone: values.phone,
        dateOfBirth: format(values.birthDate!, "yyyy-MM-dd"),
        zipCode: values.postalCode,
        licenseExpirationDate: format(
          values.licenseExpirationDate!,
          "yyyy-MM-dd"
        ),
        licenseIssuedDate: format(values.licenseIssuedDate!, "yyyy-MM-dd"),
        licenseNumber: values.licenseNumber,
        licenseState: values.licenseState.value,
        dropoffPlace: values.dropoffPlace.value,
        pickupTime: format(
          new Date(values.pickupTime.value),
          "yyyy-MM-dd'T'HH:mm:ss"
        ),

        pickupDate: format(new Date(offer.start), "yyyy-MM-dd"),
        dropoffDate: format(new Date(offer.end), "yyyy-MM-dd"),
        isAutomatic: offer.isAutomatic,
        category: offer.category.apiName,
        providerCode: offer.provider,
        pickupPlace: pickupPlace.value,
        notes: undefined,
        total: offer.cost.sale,
      })
      .then((result) => {
        setBooking(result.data);
        SendGoogleEvent('car_rental_booking');
      })
      .catch((reason: AxiosError) => {
        if (reason.response?.status === 400) {
          setHasError(true);
          setErrorMessage("Por favor revise la información introducida");
        }
      });
  };

  return {
    initialValues,
    validationSchema,
    onSubmit,
    stateslist,
    pickupTimes,
    hasError,
    setHasError,
    errorMessage,
  };
};

export default useLogic;
